import { styled } from "@mui/system";
import COLORS from "../../../../../theme/Colors";

export const LogoImg = styled("img")({
  objectFit: "contain",
  //   filter: 'brightness(0) invert(1)',
});

export const FoundationImg = styled("img")({
  width: "147px",
  aspectRatio: "3/2",
  objectFit: "contain",
  alignSelf: "center",
});

export const ModalMessage = styled("h4")({
  color: COLORS.primary,
  fontSize: "0.8em",
  fontWeight: 300,
});

export const ModalBody = styled("div")({
  display:'flex',
  flexDirection:'column',
  justifyContent: "center",
  alignItems:'center',
  padding: "32px",
  paddingTop: 0,
  textAlign: "center",
});

export const ModalTitle = styled("h1")({
  color: "#656565 !important",
  // letterSpacing: `0 !important`,
  textAlign: "center",
  fontSize: "1.5em",
  fontWeight: 300,
});

export const ModalFooter = styled("p")({
  color: "#656565",
  fontSize: "0.6em",
  fontWeight: 300,
});

export const PaymentButtonImage = styled("img")({
  objectFit: "contain",
  aspectRatio: "3/2",
  cursor: "pointer",
  width:'100%',
  height:'auto',
});


export const PaymentButton = styled("div")({
  backgroundColor: "white",
  cursor: "pointer",
  padding:'8px',
  margin:'2px',
  borderRadius:'10px',
  border: `solid 2px ${COLORS.white}`,
  ":hover": {
   // transition: '0.1s',
    border: `solid 2px ${COLORS.primary}`,
  },
});


